import { render, staticRenderFns } from "./HrBasicCorpTemp.vue?vue&type=template&id=f6924912&scoped=true&"
import script from "./HrBasicCorpTemp.vue?vue&type=script&lang=js&"
export * from "./HrBasicCorpTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6924912",
  null
  
)

export default component.exports